/**
 * Displays {@link TmState} as a row
 * @param state {TmState}
 * @param isInitial {boolean}
 * @param isFinal {boolean}
 * @param isHighlighted {boolean} if returning row must be highlighted with other bg color
 * @constructor
 */
export default function TmStateComponent({state, isInitial, isFinal, isHighlighted}) {
    return (
        <div className={(isHighlighted) ?
            'row m-0 pt-1 pb-1 height-limited-scroll-container-item container-highlighted state-highlighted' :
            'row m-0 pt-1 pb-1 height-limited-scroll-container-item'}>
            {/* state-highlighted class is only for find selected state to focus on it */}

            <div className="col-3 p-1 single-line-ellipsis-text-container text-center">
                {state.name}
            </div>

            <div className="col-5 p-1 single-line-ellipsis-text-container text-center">
                {state.description}
            </div>

            <div className="col-2 p-1 single-line-ellipsis-text-container text-center">
                {(isInitial) && (
                    <>initial</>
                )}
            </div>

            <div className="col-2 p-1 single-line-ellipsis-text-container text-center">
                {(isFinal) && (
                    <>final</>
                )}
            </div>

        </div>
    );
}